import React from 'react'
import './styles.css';
//props.option0   para ver  --Elija una opcion--

//const NuDropdown = (props) => {
  const NuDropdown = ({ 
    options = [],
    onChange = null,
    clase = '',
    name = '',
    value='',
    option0= false,
    optionAll= false,
    style={},
  }) => {

  //-------------agregamos el item con su informacion para propositos futuros
  const onChangeOption = (e) => {
    // 👇️ filter with 1 condition
    //console.log(e.target.value);
    //console.log(options)
    //---buscamos en el array, para que lo retornemos el row
    const filtered = options.filter(item => {
      return item.value === parseInt(e.target.value);
    });
    //console.log(filtered); //sino hay retorna undefined
    //---lo anexamos para ser retornado
    e.target.item = filtered[0];
    //------
    onChange(e);
  }
  //----------------------------------------------------------------
  return (
    <div className="">
      {/*<label>{props.labelName} :</label>*/}
      <select className={`mi-select ${clase}`} style={ style } 
              name={name} 
              value={value} 
              onChange={(e)=> onChangeOption(e) }  >
        {option0 &&
          <option v-if="props.option0"  key={0} value={"0"} defaultValue  >-- Elija una opción --</option>
        }
        {optionAll &&
          <option v-if="props.option0"  key={0} value={"0"} defaultValue  >-- TODOS --</option>
        }

        {
          options.map(item => (
            <option key={item.value} value={item.value} >{item.label}</option>
          ))
        }
      </select>
    </div>
  )
}
export default NuDropdown;